// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__2d-QW","logo":"Layout_logo__1VCk1"};